import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  Select,
  MenuItem,
  FormControl,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  InputLabel,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setMealCount } from "../redux/mealSlice";
import { LoadingButton } from "@mui/lab";
import OTPInput from "./OTPInput";
import { validateOtp } from "../Apis/changePasswordApis";

const ReusableDialog = ({
  open,
  onClose,
  title,
  onConfirm,
  cityName,
  mealType,
  openGuestInfoDialog,
  isLoading,
  resendOtp,
  changePasswordPath,
}) => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const mealFor = useSelector((state) => state.meal.mealFor);
  const mealCount = useSelector((state) => state.meal.mealCount);
  const guestInfo = useSelector((state) => state.meal.guestInfo);
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const capitalize = (name) =>
    name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

  const formattedGuests =
    Array.isArray(guestInfo) && guestInfo.length > 0
      ? guestInfo.length > 1
        ? `${guestInfo.slice(0, -1).map(capitalize).join(", ")} & ${capitalize(
            guestInfo[guestInfo.length - 1]
          )}`
        : capitalize(guestInfo[0])
      : "No guests available";

  const handleNumberChange = (event) => {
    const selectedMealCount = event.target.value;
    dispatch(setMealCount(selectedMealCount)); // Dispatch action to update mealCount
    // if (title === "dashboard") {
    //   navigate("/mobile/scan");
    // }
    openGuestInfoDialog();
  };

  const handleOtpComplete = (enteredOtp) => {
    setOtp(enteredOtp);
    setError("");
  };

  const handleVerify = async () => {
    setLoading(true);
    const requestDate = new Date().toISOString();
    const empId = localStorage.getItem("mealEmpId");
    try {
      const response = await validateOtp(otp, empId, requestDate);
      if (response.status) {
        navigate(`/mobile/${changePasswordPath}/${empId}`);
      } else {
        setError(response.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      setError(error.message || "An error occurred. Please try again.");
    }
    setLoading(false);
  };

  const resendOTP = async () => {
    resendOtp();
    setError("");
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (title !== "otp" || reason === "escapeKeyDown") {
          onClose();
        }
      }}
      disableEscapeKeyDown={title === "otp"}
      disableBackdropClick={title === "otp"}
    >
      {title === "dashboard" ? (
        <FormControl sx={{ m: 2, minWidth: 220 }}>
          <InputLabel id="select-label">Select Number of Guests</InputLabel>
          <Select
            labelId="select-label"
            id="select"
            label="Select Number of Guests"
            // placeholder="Select Number of Guests"
            value={mealCount}
            onChange={handleNumberChange}
            // displayEmpty
          >
            {/* <MenuItem disabled value="">
              <em>Select Number of Guests</em>
            </MenuItem> */}
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
          </Select>
        </FormControl>
      ) : title === "nav" ? (
        // Confirmation dialog for logout
        <>
          <DialogTitle textAlign="center">Confirm Logout</DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            <Typography variant="body1" sx={{ fontSize: "1rem" }}>
              Are you sure you want to logout?
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "center", pb: 3, gap: 1 }}
          >
            <Button onClick={onClose} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              variant="contained"
              sx={{ background: "#004D72 !important", color: "white" }}
            >
              Logout
            </Button>
          </DialogActions>
        </>
      ) : title === "otp" ? (
        <>
          <DialogTitle textAlign="center">
            Email Verification
            <IconButton
              aria-label="close"
              onClick={() => {
                onClose();
                setError("");
              }}
              sx={{ position: "absolute", right: 8, top: 8, color: "grey.500" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            <Typography variant="body1" sx={{ fontSize: "1rem", mb: 1 }}>
              Enter the OTP sent to your registered email address to change the
              password.
            </Typography>

            {/* OTP Input Component */}
            <OTPInput length={4} onComplete={handleOtpComplete} />

            {/* Error Message */}
            {error && (
              <Typography color="error" sx={{ mt: 1, fontSize: "0.875rem" }}>
                {error}
              </Typography>
            )}

            {/* OTP Validity */}
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ mt: 2, fontSize: "0.875rem" }}
            >
              This OTP is valid for only 10 minutes.
            </Typography>
          </DialogContent>

          {/* Buttons */}
          <DialogActions sx={{ justifyContent: "space-between", gap: 1 }}>
            <Button onClick={resendOTP}>Resend OTP?</Button>
            <LoadingButton
              loading={loading}
              variant="contained"
              color="primary"
              onClick={handleVerify}
              disabled={otp.length !== 4}
            >
              Verify
            </LoadingButton>
          </DialogActions>
        </>
      ) : (
        // Normal confirmation dialog with a title, content, and actions
        <>
          <DialogTitle textAlign="center">Confirm Service</DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            {mealFor === "guest" ? (
              <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                You have just scanned for {mealCount}{" "}
                <strong>
                  {mealType
                    ? mealType?.charAt(0).toUpperCase() +
                      mealType?.slice(1).toLowerCase()
                    : ""}
                </strong>{" "}
                for <strong>{formattedGuests}</strong> at{" "}
                <strong>
                  {cityName?.charAt(0).toUpperCase() +
                    cityName?.slice(1).toLowerCase()}
                </strong>
                . Are you sure you want to proceed with the service?
              </Typography>
            ) : (
              <Typography
                variant="body1"
                sx={{ textAlign: "center", fontSize: "1rem" }}
              >
                You have just scanned for a{" "}
                <strong>
                  {mealType
                    ? mealType?.charAt(0).toUpperCase() +
                      mealType?.slice(1).toLowerCase()
                    : ""}
                </strong>{" "}
                at{" "}
                <strong>
                  {cityName?.charAt(0).toUpperCase() +
                    cityName?.slice(1).toLowerCase()}
                </strong>
                . Are you sure you want to proceed with the service?
              </Typography>
            )}
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "center", pb: 3, gap: 1 }}
          >
            <Button onClick={onClose} variant="outlined">
              Cancel
            </Button>

            <LoadingButton
              onClick={onConfirm}
              variant="contained"
              loading={isLoading}
            >
              Proceed
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ReusableDialog;
